import React from "react";
import { Link } from "react-router-dom";

export default function Policies() {
  return (
    <main className="min-h-screen bg-[#F9F7F4] pb-32" data-testid="policies-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 pt-12 pb-10">
        <div className="label-xs text-[#ed6500] mb-3">Service policies</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#0A1128] tracking-tight">
          The fine print, in plain English.
        </h1>
        <p className="mt-3 text-[#515E7B] text-sm sm:text-base max-w-prose">
          Quick summary of how Link works, how billing happens, and what to expect on the road.
          Need anything else? See <Link to="/faqs" className="text-[#ed6500] underline-offset-4 hover:underline">FAQs</Link>.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 space-y-10">
        <Block title="Service Area">
          <p>
            We support routes up to <strong>50 miles one-way</strong>. Pickup and destination must
            both fall within our covered service zone. Routes outside this range surface an
            Out-of-range warning at booking and cannot be confirmed today.
          </p>
        </Block>

        <Block title="Billing & Payments">
          <p>
            Two payment modes are offered at the bottom of the booking surface:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>
              <strong>Weekly</strong> — recurring subscription billed in advance. Renews
              automatically. Cancel anytime from your account.
            </li>
            <li>
              <strong>One-time</strong> — single round-trip charge. No recurring billing, no auto-renewal.
            </li>
          </ul>
          <p className="mt-2">
            All payments are processed by Stripe. We never store your card details. Receipts are
            emailed automatically. The first ride for new riders gets the lowest tier rate (3+
            days/week pricing) applied to every selected day, no commitment required.
          </p>
        </Block>

        <Block title="Cancellations & Refunds">
          <p>
            One-time bookings can be cancelled up to <strong>24 hours</strong> before the
            scheduled pickup for a full refund. Weekly subscriptions can be paused or cancelled
            from your Account → Manage subscription at any time — you'll continue to receive
            rides through the end of the current paid cycle.
          </p>
        </Block>

        <Block title="Driver & Vehicle Standards">
          <p>
            Every Link driver is vetted, insured, and route-trained. Vehicles are
            inspected regularly. Live driver tracking opens automatically when a driver is
            assigned to your trip — no calling, no guessing.
          </p>
        </Block>

        <Block title="Privacy">
          <p>
            We collect only what's needed to run your trips: contact info, pickup &amp; dropoff
            addresses, and payment method (via Stripe). Location is captured during active rides
            for live tracking and is purged after the trip completes. We never sell your data.
          </p>
        </Block>

        <Block title="Not a Rideshare">
          <p>
            Link is a <strong>scheduled transportation plan</strong>. We are not a rideshare or
            on-demand service. Trips run on a fixed weekly schedule that you set up front. If
            you need a ride right now, please call a local taxi or rideshare provider.
          </p>
        </Block>
      </section>
    </main>
  );
}

function Block({ title, children }) {
  return (
    <div data-testid={`policies-block-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <h2 className="font-serif text-2xl sm:text-3xl text-[#0A1128] mb-3">{title}</h2>
      <div className="text-[#515E7B] text-sm sm:text-base leading-relaxed">{children}</div>
    </div>
  );
}
